<template>
    <div>
        <div class="modale opened" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-header">
                    <img src="../assets/salestrekker.png" alt="">
                </div>
                <div class="modal-body">
                    <p>Error while trying to forward E-Mail.</p>
                </div>
                <div class="modal-footer">
                    <button class="btn" @click="close()">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            close () {
                this.$emit('close', false);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/ErrorModal.vue